import { range } from 'presentation/utils/generalUtils';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import { cssTheme } from '@uds/theme-utils';
import { ResponsiveSet } from 'core/ribbons/primitives';

import { AspectType } from './Aspect';

// Map all values into an array and then convert to string separated by a single space
const valuesToString = (arr: Array<number>, val: string) => arr.map(() => val).join(' ');

// Map each column to each value
const columnToSameValue = (colCount: number, value: string) => {
  const rangeColumns = range(colCount);
  return valuesToString(rangeColumns, value);
};

// Get the total rows by dividing the total aspects by the columns
const getRows = (aspects: Array<AspectType>, columns: number) => Math.ceil(aspects.length / columns);

// Map the aspects to each template area
const aspectsToTemplateArea = (aspects: Array<AspectType>, columns: number, fixArea = '') => {
  const rows = getRows(aspects, columns);
  const rangeArray = range(rows);

  return valuesToString(rangeArray, `"${fixArea} ${columnToSameValue(columns, 'none')}"`);
};

const createGridTemplateAreas = (aspects: Array<AspectType>, column: number) =>
  `"${columnToSameValue(column, 'header')}" ${aspectsToTemplateArea(aspects, column)}`;

const createGridTemplateColumns = (column: number) => `repeat(${column}, minmax(auto, 1fr))`;
interface RootProps {
  columns: ResponsiveSet<number>;
  aspects: Array<AspectType>;
}

export const StyledGrid = styled.div<RootProps>`
  display: grid;
  row-gap: ${cssTheme.gu1};
  grid-template-areas: ${(props) => createGridTemplateAreas(props.aspects, props.columns[0])};
  &[data-no-header='true'] {
    grid-template-areas: ${(props) => aspectsToTemplateArea(props.aspects, props.columns[0])};
  }
  ${cssTheme.breakpoints.sm} {
    column-gap: ${cssTheme.gu2};
    row-gap: ${cssTheme.gu2};
    grid-template-areas: ${(props) => createGridTemplateAreas(props.aspects, props.columns[1])};
    &[data-no-header='true'] {
      grid-template-areas: ${(props) => aspectsToTemplateArea(props.aspects, props.columns[1])};
    }
  }
  ${cssTheme.breakpoints.md} {
    // columns should be equal width, however many, but account
    // for the fact the header is now a special column at this breapoint
    // by incrementing count by 1
    grid-template-columns: ${(props) => createGridTemplateColumns(props.columns[1] + 1)};
    grid-template-areas: ${(props) => aspectsToTemplateArea(props.aspects, props.columns[1], 'header')};
    &[data-no-header='true'] {
      grid-template-areas: ${(props) => aspectsToTemplateArea(props.aspects, props.columns[1] + 1)};
    }
  }
  ${cssTheme.breakpoints.lg} {
    // columns should be equal width, however many
    grid-template-columns: ${(props) => createGridTemplateColumns(props.columns[2] + 1)};
    // account for the header being one of the columns at this breakpoint
    // by decrementing one from the column count
    grid-template-areas: ${(props) => aspectsToTemplateArea(props.aspects, props.columns[2], 'header')};
    &[data-no-header='true'] {
      grid-template-areas: ${(props) => aspectsToTemplateArea(props.aspects, props.columns[2])};
    }
  }
`;

export default () => {
  return {
    header: css`
      grid-area: header;
    `,
    root: css`
      &[data-alignment='CENTER'] {
        text-align: center;
      }
    `,
    body: css`
      margin-top: ${cssTheme.gu2};
    `,
  };
};
